import { useState } from "react";

// Shows the whole cover (portrait or landscape) inside a fixed frame.
// Portrait covers sit on a soft, blurred copy of themselves so the frame never looks empty.
export const CoverImage = ({ src, alt, onError, testid, hoverZoom = false }) => {
  const [portrait, setPortrait] = useState(false);
  const zoom = hoverZoom ? "transition-transform duration-500 group-hover:scale-[1.03]" : "";
  return (
    <>
      {portrait && (
        <img src={src} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover scale-110 blur-xl opacity-60" />
      )}
      <img src={src} alt={alt} loading="lazy" onError={onError} data-testid={testid} data-orientation={portrait ? "portrait" : "landscape"}
        onLoad={(e) => setPortrait(e.currentTarget.naturalHeight > e.currentTarget.naturalWidth * 1.05)}
        className={`absolute inset-0 w-full h-full object-contain ${portrait ? "py-2 drop-shadow-[0_8px_16px_rgba(28,25,23,0.35)]" : "bg-white"} ${zoom}`} />
    </>
  );
};
